// Ord-pool på tværs af gennemførte niveauer (til ekstraøvelser).

import { LEVEL_6_VALID } from '../data/curriculum/grundniveau';
import { NIVEAU_1_SPRINT_WORDS } from '../data/curriculum/niveau-1';
import { NIVEAU_2_SPRINT_WORDS } from '../data/curriculum/niveau-2';
import { NIVEAU_3_SPRINT_WORDS } from '../data/curriculum/niveau-3';
import { NIVEAU_4_ALPHABET_WORDS } from '../data/curriculum/niveau-4';
import { filterWords } from '../data/curriculum/generators';
import type { UserProfile } from '../types';
import { getCumulativeUnlockedKeys } from './dictationUnits';

const TIER_CHUNKS: Record<string, string[]> = {
  grundniveau: LEVEL_6_VALID,
  'niveau-1': NIVEAU_1_SPRINT_WORDS,
  'niveau-2': NIVEAU_2_SPRINT_WORDS,
  'niveau-3': NIVEAU_3_SPRINT_WORDS,
  'niveau-4': NIVEAU_4_ALPHABET_WORDS,
};

const TIER_ORDER = [
  'grundniveau',
  'niveau-1',
  'niveau-2',
  'niveau-3',
  'niveau-4',
] as const;

export function cumulativeWordPool(user: UserProfile): string[] {
  const allowed = getCumulativeUnlockedKeys(user);
  const seen = new Set<string>();
  const out: string[] = [];

  for (const tier of TIER_ORDER) {
    if (!user.completedTierIds.includes(tier)) continue;
    const chunks = TIER_CHUNKS[tier];
    if (!chunks) continue;
    for (const word of filterWords(chunks, allowed)) {
      if (seen.has(word)) continue;
      seen.add(word);
      out.push(word);
    }
  }

  return out;
}
